import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as sectionsAccuracyActions from 'action/sectionsAccuracy'
import * as reportActions from 'action/report'
import './newsectionsaccuracy.css'
import ContentHeader from 'component/utils/ContentHeader'
import Pagination from 'component/pagination/Pagination'
import Button from 'component/Button/index'
import Radio from 'component/Radio/index'
import Form from 'component/sectionsAccuracy/Form'
import Tables from 'component/sectionsAccuracy/Tables'
import ReactHtmlParser from 'react-html-parser'

import DownloadIconSVG from 'component/svgComponents/download'
import FilterIconSVG from 'component/svgComponents/filter'
import CloseIconSVG from 'component/svgComponents/close'

const DEFAULT_SIZE = 10
const REPORT_CSV = 12
let abortController
class SectionsAccuracy extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    menu: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
    fetchSectionsAccuracy: PropTypes.func.isRequired,
    sectionsAccuracyList: PropTypes.array.isRequired,
    sectionsEffectivenessList: PropTypes.array.isRequired,
    handleResize: PropTypes.func,
    fetchReports: PropTypes.func.isRequired,
    fetchFluxReport: PropTypes.func.isRequired,
    filters: PropTypes.object,
  }

  state = {
    formData: false,
    prevFormData: false,
    sideFilterOpen: false,
    groupBy: 'store',
    effectivenessGroupBy: "withoutNexp",
    showLoader: false,
    xhr: false,
    accuracitySelected: true,
    firstFetch: false,
  }

  handleSubmit = (data) => {
    this.setState({firstFetch: false})
    this.setState({prevFormData: {...this.state.formData}})
    this.setState({ formData: data, sideFilterOpen: false }, () => {
      this.fetchData(1, this.state.accuracitySelected)
    })
  }

  fetchData = (page = 1, isAccuracy = true) => {
    const {
      fetchSectionsAccuracy,
      auth: { user },
    } = this.props

    const values = this.formatFilters()
    values.page = page
    values.hasPagination = true
    values.size = DEFAULT_SIZE
    values.isAccuracy = isAccuracy
    values.onlyNexp = this.state.effectivenessGroupBy === "onlyNexp"

    abortController = new AbortController()
    
    const xhr = fetchSectionsAccuracy(user.dsToken, values, abortController )
    this.setState({ xhr })

    document.documentElement.scrollTop = 0
  }

  handleEffectivenessGroupByChange(value) {
    this.setState({ effectivenessGroupBy: value }, () => {
      this.fetchData(1, false)
    })
  }

  handleGroupByChange(value) {
    this.setState({ groupBy: value }, () => {
      this.fetchData()
    })
  }

  getCsv = () => {
    const {
      fetchFluxReport,
      translate,
      auth: { user },
    } = this.props

    const filters = this.formatFilters()

    const values = {
      tpReport: REPORT_CSV,
    }
    abortController = new AbortController()

    const newFilters = {...filters}
    newFilters.isAccuracy = this.state.accuracitySelected
    newFilters.onlyNexp = this.state.effectivenessGroupBy === "onlyNexp"
    fetchFluxReport(user.dsToken, values, newFilters, translate, abortController, false)
  }

  formatFilters() {
    const { formData, groupBy } = this.state

    const values = {
      idBranches: [],
      idRegions: [],
      lsSections: [],
      dtYear: formData.year,
      groupBySection: groupBy === 'section' ? 'groupBySection' : '',
      groupByStore: groupBy === 'store' ? 'groupByStore' : '',
    }

    for (const branch of formData.branchs) {
      if (branch.idBranches) {
        values.idRegions.push(branch.value)
      } else {
        values.idBranches.push(branch.value)
      }
    }

    for (const section of formData.sections) {
      values.lsSections.push(section.sectionId)
    }

    return values
  }

  onCancel = () => {
    const { xhr } = this.state
    if (xhr) {
      xhr.abort()
    }
  }

  renderPagination = () => {
    const { count, current, pages } = this.props

    if (pages < 2) {
      return
    }

    return (
      <div className='align-center margin-top margin-bottom'>
        <Pagination
          count={count}
          current={current}
          getPage={this.fetchData}
          pages={pages}
        />
      </div>
    )
  }

  handleTabChange = (isAccuracy) => {
    const {firstFetch} = this.state


    if(!firstFetch && isAccuracy) {
      this.setState({firstFetch: true}, () =>  this.fetchData(1, isAccuracy))
    }

    if(!firstFetch && !isAccuracy) {
      this.setState({firstFetch: true}, () =>  this.fetchData(1, isAccuracy))
    }
 
    this.setState({accuracitySelected: isAccuracy})
  }

  render() {
    const {
      translate,
      auth: { user },
      sectionsAccuracyList,
      sectionsEffectivenessList
    } = this.props
    

  
    const { formData, groupBy, sideFilterOpen, showLoader , effectivenessGroupBy, accuracitySelected} = this.state

    return (
      <div className='section-accuracy new-style'>
        <ContentHeader>{accuracitySelected ? translate('sectionsAccuracy') : translate('sectionsEffectiveness')}</ContentHeader>

        {!formData && (
          <div className='initial-form'>
            <h2 className='margin-bottom-double'>
              {translate('mobile.filter')}
            </h2>
            <Form
              translate={translate}
              user={user}
              onSubmit={this.handleSubmit}
            />
          </div>
        )}

        {formData && (
          <>
            <div className='new-style-filter'>
              <section style={{paddingLeft: "20px"}} className='container-fluid new-upper-container'>
                <div className='col-xs-12 col-md-9 section-accuracy-left-block'>
                  <div className='first-block'>
                    <span className='show-year'>{formData.year}</span>
                    <div className='type-selection'>
                      <button onClick={() => this.handleTabChange(true)} className={ `${this.state.accuracitySelected ? "isActive" : ""}`}>Acuracidade</button>
                      <button onClick={() => this.handleTabChange(false)} className={ `${!this.state.accuracitySelected ? "isActive" : ""}`}>Efetividade</button>
                    </div>

                  </div>

                  {this.state.accuracitySelected ? <div className='group-by'>
                      <Radio
                        label={translate('sectionAccuracy.groupByStore')}
                        value={'store'}
                        name={'groupBy'}
                        onChange={(e) =>
                          this.handleGroupByChange(e.target.value)
                        }
                        checked={groupBy === 'store'}
                      />
                      <Radio
                        label={translate('sectionAccuracy.groupBySection')}
                        value={'section'}
                        name={'groupBy'}
                        onChange={(e) =>
                          this.handleGroupByChange(e.target.value)
                        }
                        checked={groupBy === 'section'}
                      />
                    </div>
                    : 
                    <div className='group-by'>
                      <Radio
                        label={"Sem NEXP"}
                        value={'withoutNexp'}
                        name={'groupBy'}
                        onChange={(e) =>
                          this.handleEffectivenessGroupByChange(e.target.value)
                        }
                        checked={effectivenessGroupBy === 'withoutNexp'}
                      />
                      <Radio
                        label={"Somente NEXP"}
                        value={'onlyNexp'}
                        name={'groupBy'}
                        onChange={(e) =>
                          this.handleEffectivenessGroupByChange(e.target.value)
                        }
                        checked={effectivenessGroupBy === 'onlyNexp'}
                      />
                    </div>
}
                  
                </div>
                <div className='col-xs-12 col-md-4'>
                  <div className='float-right'>
                    
                    <Button
                      className='btn btn-primary button-accuracy-download  margin-right'
                      text={translate('commonReport.download')}
                      onClick={this.getCsv}

                      svgIcon
                      svgComponent={<DownloadIconSVG className="download-svg-default" />}
                    />
                    <Button
                      className='btn filter-button-accuracy btn-secondary'
                      text={translate('mobile.filter')}
                      onClick={() => this.setState({ sideFilterOpen: true })}

                      svgIcon
                      svgComponent={
                        <FilterIconSVG className="margin-default-svg" newDesign={false}/>
                      }
                    />
                  </div>
                </div>
              </section>
            </div>
            
            { this.state.accuracitySelected && ( sectionsAccuracyList.length > 0 ? <Tables
              translate={translate}
              sectionsAccuracyList={sectionsAccuracyList}
              groupBy={groupBy}
            /> : this.state.accuracitySelected ? <div style={{height: "80px", marginTop: "220px"}} className='relatory-no-data'> <span>Não há cadastros no filtro selecionado</span> </div> : <div style={{height: "80px", marginTop: "220px"}} className='relatory-no-data'> <span>Não há cadastros no filtro selecionado</span> </div> )}

            { !this.state.accuracitySelected && ( sectionsEffectivenessList.length > 0 ? <Tables
              translate={translate}
              sectionsAccuracyList={sectionsEffectivenessList}
              groupBy={groupBy}
            /> : this.state.accuracitySelected ? <div style={{height: "80px", marginTop: "220px"}} className='relatory-no-data'> <span>Não há cadastros no filtro selecionado</span> </div> : <div style={{height: "80px", marginTop: "220px"}} className='relatory-no-data'> <span>Não há cadastros no filtro selecionado</span> </div> )}

            {this.renderPagination()}

            <div
              className={`right-filter-container ${
                !sideFilterOpen ? 'hidden' : ''
              }`}
            >
              <CloseIconSVG
                className="right-filter-svg"
                onClick={() => this.setState({ sideFilterOpen: false })}
              />
              <h3 className='margin-bottom-triple'>
                <strong>{translate('mobile.filter')}</strong>
              </h3>
              <Form
                isSideFilter={sideFilterOpen}
                translate={translate}
                user={user}
                onSubmit={this.handleSubmit}
                initialValues={formData}
              />
            </div>
          </>
        )}

        <div className={`new-style-loader ${showLoader ? 'show' : ''}`}>
          <div className='box'>
            <div className='icon' />
            <p className='title'>{translate('commonReport.loading.title')}</p>
            <p className='text'>
              {ReactHtmlParser(translate('commonReport.loading.text'))}
            </p>
            <button className='cancel' onClick={this.onCancel}>
              {translate('commonReport.loading.cancel')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ sectionsAccuracyReducer, paginateReducer }) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  pages: paginateReducer.pages,
  sectionsAccuracyList: sectionsAccuracyReducer.records,
  sectionsEffectivenessList: sectionsAccuracyReducer.recordsEffectiveness
  
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...sectionsAccuracyActions, ...reportActions }, dispatch)

const SectionsAccuracyTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(SectionsAccuracy)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionsAccuracyTranslated)

export { SectionsAccuracy }
